// import WinInfoController from '../../controllers/statusbar/WinInfoController';
import BalanceController from '../../controllers/statusbar/BalanceController';
import MainGridController from '../../controllers/grid/MainGridController';
import { StatusBarViewGrid } from './StatusBarViewGrid';
import { COMPONENTS } from '../../lib/constants';
// import { GameConfigs } from '../../lib/globals/GameConfigs';
// import { COMPONENTS } from "../../lib/constants";

export const StatusBar = {
	name: COMPONENTS.STATUS_BAR,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: BalanceController,
			name: 'BalanceController',
			config: {
				item: 'BALANCE_VALUE',
				val: 'BALANCE_VALUE',
				holder: 'status_bar_container'
			}
		},
		{
			Controller: MainGridController,
			name: 'GridController',
			config: {
				grid: StatusBarViewGrid,
				vc: 'status_bar_container'
			}
		}
	],
	components: [
		{
			name: 'status_bar_container',
			type: 'Sprite',
			position: { x: 0, y: 0 },
			components: [
				{
					name: 'Balance',
					type: 'Sprite',
					position: { x: 0, y: 0 },
					components: [
						{
							name: 'BALANCE_LABEL',
							type: 'Text',
							position: {
								x: 0,
								y: 0
							},
							text: 'STATUS_BAR_BALANCE_LABEL'
						},
						{
							name: 'BALANCE_VALUE',
							type: 'Text',
							position: {
								x: 0,
								y: 0
							},
							text: 'STATUS_BAR_BALANCE_VALUE'
						}
					]
				}
			]
		}
	]
};
